<!-- eslint-disable vue/no-v-html -->
<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';

// eslint-disable-next-line no-undef
const baseUrl = publicPath + modulePath || import.meta.env.VITE_BASE_URL;

const router = useRouter();

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: '',
  },
  body: {
    type: String,
    required: true,
  },
  photo: {
    type: String,
    required: false,
    default: null,
  },
});

const showPhoto = computed(() => {
  return router.currentRoute?.value.meta?.showTitleSectionPhoto;
});

const hasPhoto = computed(() => {
  return props.photo !== null && showPhoto.value;
});

const styleMask = computed(() => {
  return `url(${baseUrl}/mask/mask-header.svg)`;
});

const stylePhoto = computed(() => {
  return hasPhoto.value ? `url(${props.photo})` : '';
});
</script>

<template>
  <div
    v-if="title !== '' || body !== ''"
    class="title-section"
    :class="{ 'title-section--with-photo': hasPhoto, 'title-section--bg': showPhoto }"
  >
    <h2
      v-if="title !== ''"
      class="title"
      v-html="title"
    />
    <p
      v-if="body !== ''"
      v-html="body"
    />
  </div>
</template>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.title-section {
  margin-left: calc(var(--bs-gutter-x) * -0.5);
  margin-right: calc(var(--bs-gutter-x) * -0.5);
  padding: 1.6rem var(--bs-gutter-x) 1.6rem;

  h2.title {
    margin-bottom: 0.4rem;
    font-size: 2.4rem;

    > span {
      text-transform: capitalize;
    }
  }

  p {
    margin: 0;
  }

  @include media-breakpoint-up(lg) {
    padding: 3.2rem calc(var(--bs-gutter-x) * 0.5) 0;

    h2.title {
      font-size: 3.8rem;
    }
  }

  &--with-photo {
    background-color: transparent;
    background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), v-bind(stylePhoto);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    color: var(--ux-colors-white);
    mask-border: v-bind(styleMask);
    -webkit-mask-box-image: v-bind(styleMask) 0 0 0 0 stretch;
    mask-border-slice: 0 0 fill;
    padding: 4.8rem var(--bs-gutter-x) 7.8rem;

    @include media-breakpoint-down(lg) {
      :deep(h2) span {
        color: white;
      }
    }

    @include media-breakpoint-up(lg) {
      background-image: unset;
      mask-border: unset;
      -webkit-mask-box-image: unset;
      color: unset;
      padding: 1rem var(--bs-gutter-x) 0.4rem;
    }
  }

  &--bg {
    background-color: var(--theme-font-color-accent-25);

    @include media-breakpoint-up(lg) {
      background-color: unset;
    }
  }
}
</style>
